import { combineReducers } from "redux";
import formInput from "./formInput";

import formSearchRecruitmentReducer from "./formSearch";
import getListRecruitmentRequirementReducer from "./getListRecruitmentRequirement";
import deleteRecruitmentRequirementReducer from "./deleteRecruitmentRequirement";
import approveRecruitmentRequirementReducer from "./approveRecruitmentRequirement";
import rejectRecruitmentRequirementReducer from "./rejectRecruitmentRequirement";
import createRecruitmentReducer from "./createRecruitment";
import updateRecruitmentReducer from "./updateRecruitment";
import getDetailRecruitmentReducer from "./getDetailRecruitment";
import uploadFiles from "./uploadFiles";
import getDataBoundary from "./getDataBoundary";
import getDepartmentInfo from "./getDepartmentInfo";
import getListRecruitmentPosition from "./getListRecruitmentPosition";
import getDepartmentPositionDetail from "./getDepartmentPositionDetail";

const recruitmentReducer = combineReducers({
  formSearchRecruitmentReducer,
  getListRecruitmentRequirementReducer,
  deleteRecruitmentRequirementReducer,
  approveRecruitmentRequirementReducer,
  rejectRecruitmentRequirementReducer,
  formInput,
  createRecruitmentReducer,
  updateRecruitmentReducer,
  getDetailRecruitmentReducer,
  uploadFiles,
  getDataBoundary,
  getDepartmentInfo,
  getListRecruitmentPosition,
  getDepartmentPositionDetail,
});

export default recruitmentReducer;
